export const DEFAULT_TRANSPORT_DEMANDS = [
    {
        id: "td-default-cgo-bud",
        demand_name: "CGO → BUD",
        departure_airport: "CGO",
        arrival_airport: "BUD",
        preferred_days: [],
        preferred_time: null,
        frequency: 1,
    },
    {
        id: "td-default-hkg-bud",
        demand_name: "HKG → BUD",
        departure_airport: "HKG",
        arrival_airport: "BUD",
        preferred_days: [],
        preferred_time: null,
        frequency: 1,
    },
    {
        id: "td-default-hgh-bud",
        demand_name: "HGH → BUD",
        departure_airport: "HGH",
        arrival_airport: "BUD",
        preferred_days: [],
        preferred_time: null,
        frequency: 1,
    },
    {
        id: "td-default-hkg-lgg",
        demand_name: "HKG → LGG",
        departure_airport: "HKG",
        arrival_airport: "LGG",
        preferred_days: [],
        preferred_time: null,
        frequency: 1,
    },
];

export function getScheduleDraftTransportDemands(draft) {
    const demands = draft?.transport_demands;
    return Array.isArray(demands) ? demands : DEFAULT_TRANSPORT_DEMANDS;
}
